import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InjectionToken, Inject } from '@angular/core';
import { Injectable } from '@angular/core';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const API_BASE_URLMAIL = new InjectionToken<string>('API_BASE_URLMAIL');

@Injectable()
export class GenericRestService {
  constructor(
    @Inject(API_BASE_URL) private baseUrl: string,
    @Inject(API_BASE_URLMAIL) private baseUrlMail: string,
    private httpClient: HttpClient
  ) {}

  public get<T>(endpoint: string, params?: any): Observable<T> {
    return this.httpClient.get<T>(this.baseUrl + endpoint, { params });
  }

  public getmail<T>(endpoint: string, params?: any): Observable<T> {
    return this.httpClient.get<T>(this.baseUrlMail + endpoint, { params });
  }

  public post<T>(endpoint: string, object?: T): Observable<T> {
    return this.httpClient.post<T>(this.baseUrl + endpoint, object);
  }

  public postmail<T>(endpoint: string, object?: T): Observable<T> {
    return this.httpClient.post<T>(this.baseUrlMail + endpoint, object);
  }

  public put<T>(endpoint: string, object: T): Observable<T> {
    return this.httpClient.put<T>(this.baseUrl + endpoint, object, {});
  }

  public delete<T>(endpoint: string): Observable<T> {
    return this.httpClient.delete<T>(this.baseUrl + endpoint, {});
  }

  public patch<T>(endpoint: string, object: T): Observable<T> {
    return this.httpClient.patch<T>(this.baseUrl + endpoint, object);
  }
}
